import { render } from "./Page1.vue?vue&type=template&id=ded8a772&scoped=true"
import script from "./Page1.vue?vue&type=script&lang=js"
export * from "./Page1.vue?vue&type=script&lang=js"

import "./Page1.vue?vue&type=style&index=0&id=ded8a772&scoped=true&lang=css"

import exportComponent from "/Users/felipewalflan/Documents/Gitlab gen-t/_front/base-questionnaire/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ded8a772"]])

export default __exports__